import { IAppState } from '../../redux';

export function selectPreviousBets(state: IAppState): number[] {
  return state.auction.previousBets;
}
